import useSite from '~/client/hooks/useSite';
import Translate from '~/client/shared/i18n/Translate';
import NextLink from '~/client/shared/NextLink';
import CategoryText from './styles/CategoryText';

const getPopoverListItems = ({ blogCategories }: SiteConfig) =>
  blogCategories.map((category) => ({
    title: `blog.${category}`,
    to: `/blog/${category}`,
  }));

const Categories: FC = () => {
  const { siteConfig } = useSite();
  return (
    <div className="grid gap-2">
      {getPopoverListItems(siteConfig).map((category) => (
        <NextLink key={category?.title} href={category?.to}>
          <CategoryText size={14} color="trunks.100">
            <Translate id={category?.title} />
          </CategoryText>
        </NextLink>
      ))}
    </div>
  );
};

export default Categories;
